<template>
  <div class="support-notice">
    <vb-notice icon="envelope" title="Serve aiuto con la tua prenotazione?">
      Accedi alla sezione
      <router-link class="support-notice__link" :to="contatti_route">Contatti</router-link>. La tua richiesta verrà presa in carico da un nostro operatore e gestita nel più breve tempo possibile.
    </vb-notice>
  </div>
</template>

<script>
import VbNotice from '@library/blocks/notice.vue'

export default {
  name: 'support-notice',
  components: {
    'vb-notice': VbNotice,
  },
  props: {
    confirm_code: {
      type: String,
      default: '',
    },
    email: {
      type: String,
      default: '',
    },
  },
  computed: {
    contatti_route() {
      const query = {}
      if (this.confirm_code) query.confirmcode = this.confirm_code
      if (this.email) query.email = this.email
      return { name: 'contatti', query }
    },
  },
}
</script>

<style lang="scss" scoped>
.support-notice {
  margin-bottom: $grid-gutter-20;

  ::v-deep .vb-notice {
    border-color: transparent;
  }

  &__link {
    display: inline;
    text-decoration: underline;
  }
}
</style>
